import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 原本的
// import "@/assets/vote-theme/theme/index.css"; // 修改的

Vue.use(ElementUI, { size: 'small', zIndex: 2000 });
